import React from 'react';

type ConditionalWrapProps = React.PropsWithChildren<{
  condition: boolean;
  wrap: (children: React.ReactNode) => React.ReactElement;
}>;

const ConditionalWrap: React.FC<ConditionalWrapProps> = ({
  condition,
  wrap,
  children,
}) =>
  condition && typeof wrap === 'function' ? wrap(children) : <>{children}</>;

export default ConditionalWrap;
